// extracted by mini-css-extract-plugin
export default {"main":"Projects_main__R9W+L","box":"Projects_box__QlpEX","proj":"Projects_proj__16Be9"};